import * as service from '@/utils/request';

export function login(data) {
  return service.post('/login',data);
}

export function getInfo(token) {
  return service.fetch('/users/info',token);
}

export function logout() {
  return service.post('/logout',data);
}



// WEBPACK FOOTER //
// ./src/api/user.js